import { QueryCache, VueQueryPlugin, VueQueryPluginOptions } from '@tanstack/vue-query'

import { defineNuxtPlugin } from '#imports'
import { ApiError } from '~/api/repository'

export default defineNuxtPlugin(nuxtApp => {
  const queryPluginOptions: VueQueryPluginOptions = {
    queryClientConfig: {
      queryCache: new QueryCache({
        onError: (error) => {
          const { showToast } = useToasts()
          if (error instanceof ApiError) {
            console.error(error)
          }
          showToast({
            message: 'Request timeout. Please try again.',
            status: 'ERROR'
          })
        }
      }),
      defaultOptions: {
        queries: {
          refetchOnMount: false,
          refetchOnWindowFocus: false,
          refetchOnReconnect: false,
          refetchInterval: false,
        },
      },
    },
  }
  nuxtApp.vueApp.use(VueQueryPlugin, queryPluginOptions)
})